/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Price_RetryInputs */

const en_mk_price_retry = /** @type {(inputs: Mk_Price_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

const id_mk_price_retry = /** @type {(inputs: Mk_Price_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coba lagi`)
};

/**
* | output |
* | --- |
* | "Try again" |
*
* @param {Mk_Price_RetryInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_price_retry = /** @type {((inputs?: Mk_Price_RetryInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Price_RetryInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_price_retry(inputs)
	return en_mk_price_retry(inputs)
});